import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
/**
 * Wrapper around window.scrollTo that checks its availability:
 * no-op if window.scrollTo is not defined
 */ export var safeScrollTo = function(options) {
    if (typeof getWindowOrThrow().scrollTo !== "undefined") {
        var _getWindowOrThrow_scrollTo, _getWindowOrThrow;
        (_getWindowOrThrow_scrollTo = (_getWindowOrThrow = getWindowOrThrow()).scrollTo) === null || _getWindowOrThrow_scrollTo === void 0 ? void 0 : _getWindowOrThrow_scrollTo.call(_getWindowOrThrow, options);
    }
};
